import { render, staticRenderFns } from "./CarneAssinatura.vue?vue&type=template&id=5247242b&scoped=true&"
import script from "./CarneAssinatura.vue?vue&type=script&lang=js&"
export * from "./CarneAssinatura.vue?vue&type=script&lang=js&"
import style0 from "./CarneAssinatura.vue?vue&type=style&index=0&id=5247242b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5247242b",
  null
  
)

export default component.exports